import { baseApi, PAYMENT_SYSTEMS_TAG } from '@/shared';
import { paymentSystemsAdapter } from '../utils/helpers/adapter';

import type {
  TPaymentSystem,
  TPaymentSystemCreateParams,
  TPaymentSystemUpdateParams,
} from './types';

export const paymentSystemsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getPaymentSystems: build.query<TPaymentSystem[], void>({
      query: () => ({
        url: '/admin/payment_systems/list',
      }),
      transformResponse: paymentSystemsAdapter,
      providesTags: [PAYMENT_SYSTEMS_TAG],
    }),

    createPaymentSystem: build.mutation<void, TPaymentSystemCreateParams>({
      query: (params: TPaymentSystemCreateParams) => ({
        url: '/admin/payment_systems/create',
        method: 'POST',
        body: params,
      }),
      invalidatesTags: [PAYMENT_SYSTEMS_TAG],
    }),

    updatePaymentSystem: build.mutation<void, TPaymentSystemUpdateParams>({
      query: ({ systemId, ...params }: TPaymentSystemUpdateParams) => ({
        url: `/admin/payment_systems/update/${systemId}`,
        method: 'PUT',
        body: params,
      }),
      invalidatesTags: [PAYMENT_SYSTEMS_TAG],
    }),

    deletePaymentSystem: build.mutation<void, { systemId: number }>({
      query: ({ systemId }) => ({
        url: `/admin/payment_systems/delete/${systemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [PAYMENT_SYSTEMS_TAG],
    }),

  }),
});

export const {
  useGetPaymentSystemsQuery,
  useCreatePaymentSystemMutation,
  useUpdatePaymentSystemMutation,
  useDeletePaymentSystemMutation,
} = paymentSystemsApi;
